import { Pipe, PipeTransform } from '@angular/core'
import { RepairRequestState } from '@wm-front/admin/graphql'

export enum RepairRequestAssignationState {
  ToAssign = 'TO_ASSIGN',
  Assigned = 'ASSIGNED',
}

export type RepairRequestExtendedState =
  | RepairRequestAssignationState
  | RepairRequestState

@Pipe({
  name: 'repairRequestState',
  standalone: true,
})
export class RepairRequestStatePipe implements PipeTransform {
  /** Transform repair request state into localised string
   * @returns {string}
   * @param {RepairRequestState} value
   */

  public transform(value?: RepairRequestExtendedState): string {
    switch (value) {
      case RepairRequestState.QuoteToSend:
        return $localize`:Info Value | Value for the quote to send status @@repairRequestStatePipeQuoteToSendLabel:Quote to be sent`
      case RepairRequestState.QuoteToSignByCustomer:
        return $localize`:Info Value | Value for the quote to sign status @@repairRequestStatePipeQuoteToSignByCustomerLabel:Quote sent`
      case RepairRequestState.QuoteToVerifyPo:
        return $localize`:Info Value | Value for the quote to verify PO status @@repairRequestStatePipeQuoteToVerifyPOLabel:Verify client PO`
      case RepairRequestState.PartToWithdraw:
        return $localize`:Info Value | Value for the part to withdraw status @@repairRequestStatePipePartToWithdrawLabel:Part received`
      case RepairRequestState.PartToEstimate:
        return $localize`:Info Value | Value for the part to estimate status @@repairRequestStatePipePartToEstimateLabel:Cost to be estimated`
      case RepairRequestState.PartToIdentify:
        return $localize`:Info Value | Value for the part to identify status @@repairRequestStatePipePartToIdentifyLabel:Identify missing part`
      case RepairRequestState.PartToPurchase:
        return $localize`:Info Value | Value for the part to purchase status @@repairRequestStatePipePartToPurchaseLabel:Supplier PO to be sent`
      case RepairRequestState.PartToOrder:
        return $localize`:Info Value | Value for the part to order status @@repairRequestStatePipePartToOrderLabel:Ready to be sent to Netsuite`
      case RepairRequestState.PartToInstall:
        return $localize`:Info Value | Value for the part to install status @@repairRequestStatePipePartToInstallLabel:Part collected`
      case RepairRequestState.PartToReceive:
        return $localize`:Info Value | Value for the part to receive status @@repairRequestStatePipePartToReceiveLabel:Waiting for reception`
      case RepairRequestState.WorkToDo:
        return $localize`:Info Value | Value for the part to work to do status @@repairRequestStatePipeWorkToDoLabel:Visit to be done`
      case RepairRequestState.WorkToVerify:
        return $localize`:Info Value | Value for the part to work to verify status @@repairRequestStatePipeWorkToVerifyLabel:Visit to be verified`
      case RepairRequestAssignationState.ToAssign:
        return $localize`:Info Value | Value for the to assign status @@repairRequestStatePipeToAssignLabel:To assign`
      case RepairRequestAssignationState.Assigned:
        return $localize`:Info Value | Value for the assigned status @@repairRequestStatePipeAssignedLabel:Assign`
      case RepairRequestState.Cancelled:
        return $localize`:Info Value | Value for the canceled status @@repairRequestStatePipeCanceledLabel:Canceled`
      case RepairRequestState.Done:
        return $localize`:Info Value | Value for the quote done status @@repairRequestStatePipeQuoteDoneLabel:Quote done`
      case RepairRequestState.Denied:
        return $localize`:Info Value | Value for the quote denied status @@repairRequestStatePipeQuoteDeniedLabel:Quote denied`
      default:
        return $localize`:Info Value | Value for no status @@repairRequestStatusNoStatusLabel:No status`
    }
  }
}
